<template>
    <div class="tar-container">
        <h3>{{$t('planner.AddTargetCity')}}</h3>
        <el-form
            :label-position="'top'"
            label-width="80px"
            :model="form"
            :rules="formRule"
            ref="form"
        >
            <el-form-item :label="$t('planner.SelectInvestmentCity')">
                <el-select
                    v-model="form.city"
                    :placeholder="$t('planner.selectCity')"
                    value-key="id"
                    default-first-option
                    filterable
                >
                    <el-option-group
                        v-for="group in cities.areas"
                        :key="group.id"
                        :label="group.name"
                    >
                        <el-option
                            v-for="item in group.cities"
                            :key="item.id"
                            :label="item.name"
                            :value="item"
                        ></el-option>
                    </el-option-group>
                </el-select>
            </el-form-item>

            <h3>{{$t('planner.EstimateCity')}}</h3>

            <el-form-item
                prop="city.average_price"
                :label="$t('planner.budegtTitle')"
                class="p-relative"
            >
                <span class="prepend placeholderPend">{{cities.currency_symbol}}</span>
                <numeric-input type="number" v-model="form.city.average_price"></numeric-input>
                <span class="append placeholderPend">{{cities.currency_code}}</span>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submit">{{$t('planner.AddTargetCity')}}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { Message } from "element-ui";
import numericInput from "@/components/common/numeric-input.vue";
let loading;

export default {
    name: "editTar",
    props: ["savings", "requestParams", "requestHeaders", "collection"],
    data() {
        const $t = this.$t.bind(this);
        return {
            form: {
                city: {
                    average_price: ""
                }
            },

            formRule: {
                "city.average_price": {
                    required: true,
                    message: $t("planner.budgetError"),
                    trigger: ["blur", "change"]
                }
            },

            cities: {},
            value: "0"
        };
    },

    beforeMount() {
        this.initialCities();
    },

    mounted() {},

    methods: {
        loading() {
            loading = this.$loading({
                lock: true,
                target: ".main-container",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        initialCities() {
            this.loading();
            let cities = `${this.requestParams.ppbApi}api/savings/cities-rates/`;
            this.$http
                .get(cities, this.requestHeaders)
                .then(result => {
                    this.cities = result.data;
                    this.form.city = this.cities.areas[0].cities[0];
                    loading.close();
                })
                .catch(err => {});
        },

        submit() {
            let params = this.$refs["form"].model;
            this.$refs["form"].validate(valid => {
                if (!valid) {
                } else {
                    this.loading();
                    let budgetUrl = `${this.requestParams.ppbApi}api/savings/investment/`;
                    let parameters = {
                        city: this.form.city.id,
                        value: this.form.city.average_price
                    };

                    this.$http
                        .post(budgetUrl, parameters, this.requestHeaders)
                        .then(result => {
                            loading.close();
                            if (result.status == "201") {
                                this.triggerMessage("success", {
                                    message: this.$t(
                                        "planner.addTargetCitySuccess"
                                    )
                                });
                                this.$emit("goTo", "");
                            }
                        })
                        .catch(err => {
                            this.triggerMessage("error", {
                                message: this.$t("planner.addTargetCityError")
                            });
                            loading.close();
                        });
                }
            });
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    watch: {},

    components: {
        numericInput
    }
};
</script>

<style lang="scss">
.tar-container {
    .el-form {
        .el-form-item__label {
            line-height: normal;
            height: auto;
        }
    }

    .el-select {
        width: 100%;
        margin-bottom: 30px;
        .el-input__inner {
            height: 40px;
            border-radius: 4px;
            border: solid 1px #e0e7ff;
            background-color: rgba(224, 231, 255, 0.2);
        }
    }

    .p-relative {
        position: relative;
        .el-form-item__label {
            width: 100% !important;
            margin-bottom: 10px;
            float: unset;
            padding: 0;
        }
        .el-form-item__content {
            margin: 0 !important;
            .el-input {
                .el-input__inner {
                    padding-left: 35px;
                    height: 40px;
                    border-radius: 4px;
                    border: solid 1px #e0e7ff;
                    background-color: rgba(224, 231, 255, 0.2);
                }
            }
        }
        .placeholderPend {
            z-index: 2;
            position: absolute;
            top: 0;
            font-size: 14px;
            font-weight: 500;
            color: var(--brownish-grey);
        }
        .append {
            right: 16px;
            font-family: GothamMedium;
        }
        .prepend {
            left: 16px;
            font-family: GothamBook;
        }
    }

    .el-button {
        border: none;
        box-shadow: none;
        width: 100%;
        border-radius: 4px;
        background-color: var(--windows-blue);
        font-family: GothamMedium;
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
        color: var(--white);
        &:hover,
        &:focus {
            background-color: var(--windows-blue);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/account/createTar.vue